module.exports = __webpack_public_path__ + "img/loader.f4e2a79f.gif";